import { get } from './api.service';
import { URL_OUTLET } from '@constants/api.constants';

const endpointOutlet = URL_OUTLET;

export const getListPOS = (outletId: string) => {
	return get(`${endpointOutlet}/${outletId}/pos `);
};
